import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Anlagentyp } from '../../domain/model/anlagentyp';

@Injectable({
    providedIn: 'root',
})
export class AnlagentypService {
    private http = inject(HttpClient);


    /**
     * Gets all types of Anlagentypen and transforms into real TypeScript objects
     * @returns {Observable<Anlagentyp>}
     */
    public getAnlagentypen(): Observable<Anlagentyp[]> {
        return this.http.get(environment.API_URL + '/anlagentyp') as Observable<Anlagentyp[]>;
    }
}
